const translations = {
  title: 'Enviando Formulario',
  subtitle: 'Complete los campos a continuación para enviar el formulario',
  form: 'Formulario a enviar',
  placeField: 'Campo de email',
  'guide.title': 'Seleccione los locales para enviar el formulario: ',
  'guide.title_person': 'Seleccione las personas para enviar el formulario: ',
  'guide.fleet': 'Seleccione las Flotas para enviar el formulario: ',
  'guide.help': '¿Necesita ayuda? Haga clic aquí para iniciar el tour',
  'tour.selectRow.title': 'Seleccione el destinatario',
  'tour.selectRow.message': 'En la página de locales, comience seleccionando a quién desea enviar el formulario.',
  'tour.selectRow.message_person':
    'En la página de personas, comience seleccionando a quién desea enviar el formulario.',
  'tour.selectRow.message_fleet':
    'En la página de personas, comience seleccionando a quién desea enviar el formulario.',
  'tour.selectRow.subMessage': '(Haga clic en el checkbox para continuar)',
  'tour.sendForm.title': 'Haga clic en "Enviar Formulario"',
  'tour.sendForm.message': 'Cuando finalice la selección, haga clic en Enviar Formulario en el menú inferior',
  'tour.sendForm.subMessage': '(Haga clic en el botón para continuar)',
  'tour.selectForm.title': 'Seleccione qué formulario',
  'tour.selectForm.message': 'Complete qué formulario se enviará',
  'tour.selectForm.subMessage': '',
  'tour.selectField.title': 'Seleccione el campo de email',
  'tour.selectField.message': 'Complete qué campo de email se enviará.',
  'tour.selectField.subMessage':
    '(Si no tiene un campo de email, es necesario configurarlo antes. Solicite al administrador del sistema que lo haga.)',
  'tour.finish.title': '¡Listo! ¡Eso es todo!',
  'tour.finish.message':
    'Después solo haga clic en el botón de enviar y todos los seleccionados recibirán un email con instrucciones de cómo iniciar.',
  'tour.finish.subMessage':
    '(Recuerde que puede usar los filtros en la parte superior de la tabla para facilitar la selección)'
}

export default translations
